//include 4 
jQuery(function(){
    var broshuresList = $(".broshures-list");
    var broshuresOrderForm = $(".order-broshures");
    if (broshuresList.length == 0)
        return;

    $(window).on("load", function () {
        equalHeight($(".broshures-list .tabgallery .tabs-content .tabs-panel .list .broshure"), true);
    });

    $(window).on("orientationchange resize", function () {
        equalHeight($(".broshures-list .tabgallery .tabs-content .tabs-panel .list .broshure"), true);
    });

    $('.broshures-list ul.tabs').on('change.zf.tabs', function (event, tab) {
        equalHeight($(".broshures-list .tabgallery .tabs-content .tabs-panel .list .broshure"), true);
    });

    if (broshuresOrderForm.length == 0)
        return;

    var formValid = false;

    var modalInstance = null; 

    //************************************************
    var privateFunctions = {
        /*=====  End of participant functions  ======*/
        /*=====================================================================
        =            creating data object and sending it to server            =
        =====================================================================*/
        getContactData() {
            var contactData = {};
            //independent roles
            contactData.roles = privateFunctions.gatherIndependentRolesData();
            return contactData;
        },
        gatherIndependentRolesData: function () {
            var rolesData = {};
            broshuresOrderForm.find(".brandenform > div.role").each(function () {
                var $this = $(this);
                var salutation = $this.find("[name='salutation']").val();
                var title = $this.find("[name='title']").val();
                var firstname = $this.find("[name='firstname']").val();
                var lastname = $this.find("[name='lastname']").val();
                var firma = $this.find("[name='firma']").val();
                var strasse = $this.find("[name='strasse']").val();
                var plz = $this.find("[name='plz']").val();
                var ort = $this.find("[name='ort']").val();
                var country = $this.find("[name='country']").val();
                var language = $this.find("[name='language']").val();
                var telefon = $this.find("[name='telefon']").val();
                var email = $this.find("[name='email']").val();
                //when dealing with broshures, we select the role type ids on the server, here we just add one item to the array
                rolesData[0] = {
                    'personType': salutation,
                    'title': title,
                    'firstName': firstname,
                    'lastName': lastname,
                    'companyName': firma,
                    'street': strasse,
                    'zipCode': plz,
                    'city': ort,
                    'country': country,
                    'phone': telefon,
                    'eMail': email,
                    'preferredCommunicationType': 1,
                    'correspondenceLanguageCode': language
                };
            });
            return rolesData;
        },
        getSelectedBroshures: function(){
            var selected = [];
            broshuresList.find("input[type='checkbox']:checked").each(function () {
                selected.push($(this).val());
            });
            return selected;
        },
        getSelectedBroshuresData: function(){
            var data = {};
            broshuresList.find("input[type='checkbox']:checked").each(function () {
                var broshure = $(this).closest(".broshure");
                var broshureId = $(this).data("checkbox-checkall");
                var title = broshure.find("[data-broshure-check-title]").text() || "";
                var description = broshure.find("[data-broshure-check-description]").html() || "";
                var image = broshure.find("[data-broshure-check-image]").attr("src") || "";
                data[broshureId] = {
                    title: title,
                    description: description,
                    image:image
                };
            });
            return data;
        },
        submitData: function() {
            var selectedBroshures = this.getSelectedBroshures();
            var broshuresData = this.getSelectedBroshuresData();
            var contactData = this.getContactData();
            if (selectedBroshures.length == 0) {
                alert(window.ppt.translate("broshures.required","Bitte wählen sie erst Prospekte aus"));
                return;
            }

            var subscribeToNewsletter = $("input#newsletter").is(":checked");

            var parameters = {
                "broshureIds": selectedBroshures,
                "contactData": contactData,
                "broshuredata": broshuresData
            };
            if(!!subscribeToNewsletter){
                parameters.newsletter = 1;
            }

            window.pixelpoint.pubSub.publish('loader:order-broshures-loader:show');
            var defer;
            
            var useTomasFlag = broshuresOrderForm.find(".brandenform").find("input[name='tomasOrder']");
            if(useTomasFlag.length > 0){
                useTomasFlag = useTomasFlag.val();
            }
            else{
                useTomasFlag = "1";
            }

            parameters.useTomas = useTomasFlag;

            if(useTomasFlag == "0"){
                var orderEmail = broshuresOrderForm.find(".brandenform").find("input[name='orderEmail']");
                if(orderEmail.length > 0){
                    parameters.orderEmail = orderEmail.val();
                }
            }

            var countryTextual = $("[name='countryTextual']");
            if(countryTextual.length > 0){
                parameters.countryTextual = countryTextual.val();
            }

            $.ajax({
                url: window.pixelpoint.utilities.getAjaxUrl("/index.php?action=orderBroshures&type=1732176051"),
                method: 'POST',
                data: {
                    parameters: parameters
                },
                success: function (data) {
                    broshuresOrderForm.addClass("submitted");
                    //broshuresOrderForm.find(".success.callout").removeClass("hide");

                    var selectedBroshures = [];
                    $.each(broshuresData,function(index,broshure){
                        selectedBroshures.push(broshure.title);
                    });

                    window.pixelpoint.tagManager.event("prospektBestellt",{
                        prospektNamen:selectedBroshures.join(", ")
                    });

                    lity("#broshures-order-success");
                    privateFunctions.resetForm();
                },
                error: function () {
                    lity("#broshures-order-fail");
                },
                complete: function () {
                    window.pixelpoint.pubSub.publish('loader:order-broshures-loader:hide');
                }
            });

            /*
            window.pixelpoint.orderBroshures({
                parameters: parameters
            }).done(function (response) {
                broshuresOrderForm.addClass("submitted");
                //broshuresOrderForm.find(".success.callout").removeClass("hide");

                var selectedBroshures = [];
                $.each(broshuresData,function(index,broshure){
                    selectedBroshures.push(broshure.title);
                });

                window.pixelpoint.tagManager.event("prospektBestellt",{
                    prospektNamen:selectedBroshures.join(", ")
                });

                lity("#broshures-order-success");
                privateFunctions.resetForm();
            })
            .fail(function () {
                lity("#broshures-order-fail");
            })
            .always(function () {
                window.pixelpoint.pubSub.publish('loader:order-broshures-loader:hide');
            });
            */

        },
        resetForm() {
            privateFunctions.enableOrDisableSubmit();

            //reset all checked broshures (check-image and text link)
            var broshuresListAfterOrder = $(".broshures-list");
            var selectedAfterOrder = [];
            broshuresListAfterOrder.find("input[type='checkbox']:checked").each(function () {
                selectedAfterOrder.push($(this).val());
                broshuresListAfterOrder.find("div.add-broshure[data-tomas-id='" + $(this).val() + "']").toggle();
                broshuresListAfterOrder.find("label.add-broshure[data-tomas-id='" + $(this).val() + "']").find("span.add-icon").toggle();
                broshuresListAfterOrder.find("label.add-broshure[data-tomas-id='" + $(this).val() + "']").find("span.added-icon").toggle();
            });

            var form = $(".brandenform");
            form[0].reset();
            form.find(".select2-hidden-accessible").trigger("change");
            form[0].reset();
        },
        enableOrDisableSubmit: function () {
            var selected = this.getSelectedBroshures();
            var wasAlreadySubmitted = broshuresOrderForm.hasClass("submitted");
            if (selected.length == 0 || wasAlreadySubmitted) {
                broshuresOrderForm.find(".submit-form").addClass("disabled");
            }
            else {
                broshuresOrderForm.find(".submit-form").removeClass("disabled");
            }
        }
    }
    //************************************************
    broshuresOrderForm.on("click", ".submit-form", function (e) {
        e.preventDefault();
        broshuresOrderForm.find(".success.callout").addClass("hide");
        if (broshuresOrderForm.find(".submit-form").hasClass("disabled"))
            return;
        broshuresOrderForm.find('.brandenform').foundation('validateForm');

        setTimeout(function () {
            Foundation.reInit('equalizer');
        },100);
        
        if (!!formValid) {
            var template = $("#broshures-order-check").html();
            var compiled = _.template(template);
            var data = privateFunctions.getSelectedBroshuresData();
            var html = compiled({ data: data });
            if(typeof html == "function")
                html = html({ data: data });
            modalInstance = lity(html);
            var modal = modalInstance.element();
            modal.find("a.brosures-order").off("click").on("click", function (e) {
                e.preventDefault();
                privateFunctions.submitData();
                modalInstance.close();
            });
            modal.find("a.brosures-change-selection").off("click").on("click", function (e) {
                e.preventDefault();
                modalInstance.close();
                window.pixelpoint.utilities.scrollTo(`.tabgallery-wrapper.broshures-list`);
            });
        }
        else{
            var firstError = $(".is-invalid-input").first();
            var errorCallout = $('.alert.callout');

            if (firstError.length > 0){
                if(errorCallout.offset().top < firstError.offset().top){
                    window.pixelpoint.utilities.scrollTo(errorCallout);
                }
                else {
                    window.pixelpoint.utilities.scrollTo(firstError);
                }
            }
            else {
                window.pixelpoint.utilities.scrollTo(errorCallout);
            }

            /*
            if(firstError.length > 0) {
                window.pixelpoint.utilities.scrollTo(firstError);
            } else {
                window.pixelpoint.utilities.scrollTo(errorCallout);
            }
            */
        }
    });

    broshuresList.on("change", "input[type='checkbox']", function () {
        broshuresList.find("div.add-broshure[data-tomas-id='" + $(this).val() + "']").toggle();

        privateFunctions.enableOrDisableSubmit();
    });

    broshuresOrderForm.on('formvalid.zf.abide', '.brandenform', function () {
        formValid = true;
    });
    broshuresOrderForm.on('forminvalid.zf.abide', '.brandenform', function () {
        formValid = false;
    });

});